parcelRequire.extendImportMap({"kWRtk":"web-vitals.7f21e881.js"});